import { createFileRoute } from '@tanstack/react-router'

import { ChangePaymentMethodSuccessPage } from '~/boundedContext/subscription/pages/change-payment-method-success-page'

import { changePaymentMethodSuccessSearchSchema } from '../../-schemas/change-payment-method-success-schema'

export const Route = createFileRoute('/_main-layout/settings/subscription/change-payment-method-success')({
  component: ChangePaymentMethodSuccessPage,
  validateSearch: search => changePaymentMethodSuccessSearchSchema.parse(search),
})
